import { PublishRulesCategoriesEnum } from '../enums/publishRulesCategoriesEnum';
import { IPublishRulesTreeItem } from '../interfaces/IPublishRulesTreeItem';

export const getTree: () => IPublishRulesTreeItem[] = () => [
  {
    id: '1',
    title: 'Контрольные (надзорные) мероприятия',
    category: PublishRulesCategoriesEnum.KNM,
    children: [
      {
        id: '1-1',
        title: 'Плановые КНМ',
        category: PublishRulesCategoriesEnum.PLANNED_KNM,
        editable: true,
        children: [
          {
            id: '1-1-1',
            title: 'Контрольная закупка',
            category: PublishRulesCategoriesEnum.PLANNED_KNM_KZ,
            editable: true,
          },
          {
            id: '1-1-2',
            title: 'Рейдовый осмотр',
            category: PublishRulesCategoriesEnum.PLANNED_KNM_RO,
            editable: true,
          },
          {
            id: '1-1-3',
            title: 'Выборочный контроль',
            category: PublishRulesCategoriesEnum.PLANNED_KNM_VK,
            editable: true,
          },
          {
            id: '1-1-4',
            title: 'Инспекционный визит',
            category: PublishRulesCategoriesEnum.PLANNED_KNM_IV,
            editable: true,
          },
          {
            id: '1-1-5',
            title: 'Мониторинговая закупка',
            category: PublishRulesCategoriesEnum.PLANNED_KNM_MZ,
            editable: true,
          },
          {
            id: '1-1-6',
            title: 'Документарная проверка',
            category: PublishRulesCategoriesEnum.PLANNED_KNM_DP,
            editable: true,
          },
          {
            id: '1-1-7',
            title: 'Выездная проверка',
            category: PublishRulesCategoriesEnum.PLANNED_KNM_VP,
            editable: true,
          },
        ],
        expansible: true,
        defaultExpanded: true,
      },
      {
        id: '1-2',
        title: 'Внеплановые КНМ',
        category: PublishRulesCategoriesEnum.UNPLANNED_KNM,
        editable: true,
        children: [
          {
            id: '1-2-1',
            title: 'Контрольная закупка',
            category: PublishRulesCategoriesEnum.UNPLANNED_KNM_KZ,
            editable: true,
          },
          {
            id: '1-2-2',
            title: 'Рейдовый осмотр',
            category: PublishRulesCategoriesEnum.UNPLANNED_KNM_RO,
            editable: true,
          },
          {
            id: '1-2-3',
            title: 'Выборочный контроль',
            category: PublishRulesCategoriesEnum.UNPLANNED_KNM_VK,
            editable: true,
          },
          {
            id: '1-2-4',
            title: 'Инспекционный визит',
            category: PublishRulesCategoriesEnum.UNPLANNED_KNM_IV,
            editable: true,
          },
          {
            id: '1-2-5',
            title: 'Мониторинговая закупка',
            category: PublishRulesCategoriesEnum.UNPLANNED_KNM_MZ,
            editable: true,
          },
          {
            id: '1-2-6',
            title: 'Документарная проверка',
            category: PublishRulesCategoriesEnum.UNPLANNED_KNM_DP,
            editable: true,
          },
          {
            id: '1-2-7',
            title: 'Выездная проверка',
            category: PublishRulesCategoriesEnum.UNPLANNED_KNM_VP,
            editable: true,
          },
        ],
        expansible: true,
      },
    ],
    editable: false,
    defaultExpanded: true,
  },
  {
    id: '2',
    title: 'Профилактические мероприятия',
    category: PublishRulesCategoriesEnum.PM,
    children: [
      {
        id: '2-1',
        title: 'Профилактический визит',
        category: PublishRulesCategoriesEnum.PM_PP,
        editable: true,
      },
      {
        id: '2-2',
        title: 'Объявление предостережения',
        category: PublishRulesCategoriesEnum.PM_OP,
        editable: true,
      },
    ],
    editable: false,
    expansible: false,
    defaultExpanded: true,
  },
  {
    id: '3',
    title: 'Проверки',
    category: PublishRulesCategoriesEnum.PM_CHECKS,
    children: [
      {
        id: '3-1',
        title: 'Плановые проверки',
        category: PublishRulesCategoriesEnum.PLANNED_PM_CHECKS,
        editable: true,
        children: [
          {
            id: '3-1-1',
            title: 'Выездная проверка',
            category: PublishRulesCategoriesEnum.PLANNED_PM_CHECKS_VP,
            editable: true,
          },
          {
            id: '3-1-2',
            title: 'Документарная проверка',
            category: PublishRulesCategoriesEnum.PLANNED_PM_CHECKS_DP,
            editable: true,
          },
          {
            id: '3-1-3',
            title: 'Контрольная закупка',
            category: PublishRulesCategoriesEnum.PLANNED_PM_CHECKS_KZ,
            editable: true,
          },
        ],
        expansible: true,
      },
      {
        id: '3-2',
        title: 'Внеплановые проверки',
        category: PublishRulesCategoriesEnum.UNPLANNED_PM_CHECKS,
        editable: true,
        children: [
          {
            id: '3-2-1',
            title: 'Выездная проверка',
            category: PublishRulesCategoriesEnum.UNPLANNED_PM_CHECKS_VP,
            editable: true,
          },
          {
            id: '3-2-2',
            title: 'Документарная проверка',
            category: PublishRulesCategoriesEnum.UNPLANNED_PM_CHECKS_DP,
            editable: true,
          },
          {
            id: '3-2-3',
            title: 'Контрольная закупка',
            category: PublishRulesCategoriesEnum.UNPLANNED_PM_CHECKS_KZ,
            editable: true,
          },
        ],
        expansible: true,
      },
    ],
    editable: false,
    expansible: false,
    defaultExpanded: true,
  },
  {
    id: '4',
    title: 'Иные решения',
    category: PublishRulesCategoriesEnum.DECISION_PASSPORT,
    editable: true,
    expansible: false,
    defaultExpanded: false,
  },
];
